var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHeinsohn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.382,
    height: 33.916,
    viewBox: "0 0 114.382 33.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.728,
    y1: 0.393,
    x2: 9.559,
    y2: 0.592,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8204f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be0031"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16932",
    "data-name": "Grupo 16932",
    transform: "translate(841.5 -738.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3905",
    "data-name": "Grupo 3905",
    transform: "translate(-802.225 749.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4832",
    "data-name": "Trazado 4832",
    d: "M248.879,58.15V53.476H245.1V58.15h-2.18V46.983h2.18v4.564h3.78V46.983h2.181V58.15Z",
    transform: "translate(-242.92 -46.889)",
    fill: "#1b202c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4833",
    "data-name": "Trazado 4833",
    d: "M310.027,58.15V46.983h7.356v1.945h-5.176v2.619h4.407v1.945h-4.407V56.2h5.176V58.15Z",
    transform: "translate(-299.316 -46.889)",
    fill: "#1b202c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2325",
    "data-name": "Rect\\xE1ngulo 2325",
    width: 2.18,
    height: 11.167,
    transform: "translate(20.169 0.094)",
    fill: "#1b202c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4834",
    "data-name": "Trazado 4834",
    d: "M405.651,58.15,401.228,51.3V58.15h-2.18V46.983h1.945l4.422,6.838V46.983H407.6V58.15Z",
    transform: "translate(-374.127 -46.889)",
    fill: "#1b202c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4835",
    "data-name": "Trazado 4835",
    d: "M470.637,54.362a3.038,3.038,0,0,1-1.2,2.5,4,4,0,0,1-1.309.659,5.624,5.624,0,0,1-1.631.227,7.393,7.393,0,0,1-2.267-.321,4.436,4.436,0,0,1-1.812-1.153l1.412-1.412a2.846,2.846,0,0,0,1.224.737,5.184,5.184,0,0,0,1.474.2A2.56,2.56,0,0,0,468,55.452a1.179,1.179,0,0,0,.5-1.028,1.235,1.235,0,0,0-.345-.94,1.3,1.3,0,0,0-.384-.244,2.857,2.857,0,0,0-.6-.149l-1.348-.188a3.778,3.778,0,0,1-2.165-.925,2.969,2.969,0,0,1-.8-2.2,3.432,3.432,0,0,1,.267-1.373,2.989,2.989,0,0,1,.768-1.066,3.578,3.578,0,0,1,1.224-.7,4.951,4.951,0,0,1,1.631-.251,6.228,6.228,0,0,1,2.023.3,4.261,4.261,0,0,1,1.584,1l-1.38,1.365a2.424,2.424,0,0,0-1.137-.635,5.38,5.38,0,0,0-1.153-.133,1.791,1.791,0,0,0-1.3.416,1.343,1.343,0,0,0-.424,1,1.181,1.181,0,0,0,.078.423,1.081,1.081,0,0,0,.252.377,1.645,1.645,0,0,0,.431.274,2.151,2.151,0,0,0,.6.165l1.317.188a5.2,5.2,0,0,1,1.271.321,3,3,0,0,1,.862.541,2.462,2.462,0,0,1,.659,1.019,4.17,4.17,0,0,1,.2,1.349",
    transform: "translate(-427.382 -46.395)",
    fill: "#1b202c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4836",
    "data-name": "Trazado 4836",
    d: "M532.479,52.072q0,.722-.016,1.349a7.328,7.328,0,0,1-.118,1.175,4.1,4.1,0,0,1-.329,1.028,3.225,3.225,0,0,1-.651.9,4,4,0,0,1-3.011,1.223,4.294,4.294,0,0,1-1.693-.313,4.2,4.2,0,0,1-1.334-.91,3.239,3.239,0,0,1-.65-.9,3.912,3.912,0,0,1-.322-1.028,8.052,8.052,0,0,1-.109-1.175q-.016-.628-.016-1.349t.016-1.348a8.073,8.073,0,0,1,.109-1.176,3.911,3.911,0,0,1,.322-1.028,3.238,3.238,0,0,1,.65-.9,4.207,4.207,0,0,1,1.334-.91,4.294,4.294,0,0,1,1.693-.314,4,4,0,0,1,3.011,1.223,3.224,3.224,0,0,1,.651.9,4.1,4.1,0,0,1,.329,1.028,7.347,7.347,0,0,1,.118,1.176q.016.628.016,1.348m-2.18,0q0-.8-.023-1.325a6.874,6.874,0,0,0-.086-.87,2.008,2.008,0,0,0-.172-.557,1.824,1.824,0,0,0-.266-.384,1.777,1.777,0,0,0-.589-.432,1.89,1.89,0,0,0-.808-.164,1.952,1.952,0,0,0-.816.164,1.756,1.756,0,0,0-.6.432,1.588,1.588,0,0,0-.259.384,2.169,2.169,0,0,0-.164.557,6.553,6.553,0,0,0-.087.87q-.023.525-.023,1.325t.023,1.326a6.564,6.564,0,0,0,.087.87,2.181,2.181,0,0,0,.164.557,1.588,1.588,0,0,0,.259.384,1.741,1.741,0,0,0,.6.431,1.937,1.937,0,0,0,.816.165,1.876,1.876,0,0,0,.808-.165,1.762,1.762,0,0,0,.589-.431,1.824,1.824,0,0,0,.266-.384,2.018,2.018,0,0,0,.172-.557,6.887,6.887,0,0,0,.086-.87q.024-.527.023-1.326",
    transform: "translate(-479.327 -46.395)",
    fill: "#1b202c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4837",
    "data-name": "Trazado 4837",
    d: "M595.622,58.15V53.476h-3.78V58.15h-2.18V46.983h2.18v4.564h3.78V46.983h2.18V58.15Z",
    transform: "translate(-534.315 -46.889)",
    fill: "#1b202c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4838",
    "data-name": "Trazado 4838",
    d: "M663.38,58.15,658.957,51.3V58.15h-2.179V46.983h1.944l4.423,6.838V46.983h2.18V58.15Z",
    transform: "translate(-590.718 -46.889)",
    fill: "#1b202c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3906",
    "data-name": "Grupo 3906",
    transform: "translate(-841 739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4839",
    "data-name": "Trazado 4839",
    d: "M27.161,6.76A22.632,22.632,0,0,0,16.752.665C12.469-.48,8.73-.151,5.56,1.692v.023C1.845,3.84,0,7.273,0,11.944A18.027,18.027,0,0,0,3.265,22.266,25.22,25.22,0,0,0,6.742,26.4c4.448,4.32,9.37,6.492,14.716,6.516,4.685,0,8.163-1.775,10.387-5.277a11.789,11.789,0,0,0,1.774-5.372,14.853,14.853,0,0,0-.5-5.3A21.812,21.812,0,0,0,27.161,6.76M16.987,2.37a19.728,19.728,0,0,1,9.2,5.3,19.47,19.47,0,0,1,5.228,9.014,13.291,13.291,0,0,1,.213,5.581A10.211,10.211,0,0,1,30.1,25.933c-1.964,2.918-4.993,4.32-9.063,4.249-4.494-.092-8.611-1.984-12.349-5.6a22.811,22.811,0,0,1-2.059-2.312,16.285,16.285,0,0,1-3.786-9.9C2.767,8.372,4.258,5.406,7.358,3.49V3.467c2.7-1.681,5.891-2.032,9.629-1.1",
    transform: "translate(0 0)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4840",
    "data-name": "Trazado 4840",
    d: "M134.088,48.031c-.5-.117-.687.094-.616.56l.19,1.214a1.022,1.022,0,0,0,.9.864l1.278.257c.45.093.638-.117.544-.584l-.19-1.167a1.075,1.075,0,0,0-.876-.865Z",
    transform: "translate(-112.155 -40.338)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4841",
    "data-name": "Trazado 4841",
    d: "M69.99,37.142c.568.093.8-.118.756-.608l-.165-1.285a1,1,0,0,0-.9-.934l-1.491-.327c-.568-.117-.827.093-.781.584l.143,1.308c.023.514.33.817.923.934Z",
    transform: "translate(-56.646 -28.537)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4842",
    "data-name": "Trazado 4842",
    d: "M151.432,134.428l-.284-1.5c-.117-.584-.4-.887-.922-.911l-1.372-.162c-.52-.047-.757.21-.638.77l.26,1.541a1,1,0,0,0,.97.934l1.4.117c.5.047.71-.234.592-.793",
    transform: "translate(-124.531 -110.808)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4843",
    "data-name": "Trazado 4843",
    d: "M139.506,68.69a.971.971,0,0,0-.852-.841l-1.253-.21c-.52-.118-.734.092-.663.56l.237,1.285a1.021,1.021,0,0,0,.9.887l1.3.21c.473.07.662-.14.592-.606Z",
    transform: "translate(-114.901 -56.816)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4844",
    "data-name": "Trazado 4844",
    d: "M140.36,88.557l.236,1.4a1,1,0,0,0,.923.887l1.3.163c.5.07.71-.14.617-.653l-.261-1.331a.974.974,0,0,0-.875-.865l-1.278-.233c-.543-.071-.78.14-.661.631",
    transform: "translate(-117.931 -73.88)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4845",
    "data-name": "Trazado 4845",
    d: "M72.608,56.126a1.05,1.05,0,0,0-.923-.934l-1.537-.28c-.569-.117-.852.093-.8.607l.117,1.4a1.034,1.034,0,0,0,.97.957l1.562.234c.545.116.8-.117.756-.631Z",
    transform: "translate(-58.27 -46.121)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4846",
    "data-name": "Trazado 4846",
    d: "M74.106,80.206c.592.093.828-.163.758-.7L74.7,78.081a1,1,0,0,0-.946-.981l-1.563-.234c-.591-.117-.875.117-.8.677l.118,1.473a.988.988,0,0,0,.994.956Z",
    transform: "translate(-59.981 -64.572)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4847",
    "data-name": "Trazado 4847",
    d: "M100.774,103.468l-1.514-.21c-.592-.093-.828.164-.758.747l.166,1.519a1.042,1.042,0,0,0,.994.98l1.561.165q.816.069.711-.771l-.215-1.495a.992.992,0,0,0-.946-.934",
    transform: "translate(-82.77 -86.76)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4848",
    "data-name": "Trazado 4848",
    d: "M76.258,103.433c.592.093.876-.187.8-.748L76.9,101.12a1.062,1.062,0,0,0-.994-.98l-1.585-.21c-.615-.07-.923.186-.851.747l.142,1.588a1.036,1.036,0,0,0,1.016,1.027Z",
    transform: "translate(-61.731 -83.97)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4849",
    "data-name": "Trazado 4849",
    d: "M78.192,124.675l-1.632-.164c-.663-.07-.946.186-.876.841l.166,1.658a.974.974,0,0,0,1.041,1.027l1.68.14c.615.047.9-.256.827-.841l-.189-1.657a1.05,1.05,0,0,0-1.017-1",
    transform: "translate(-63.595 -104.628)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4850",
    "data-name": "Trazado 4850",
    d: "M146.977,110.323a.957.957,0,0,0-.874-.887l-1.3-.186c-.544-.094-.781.14-.685.7l.236,1.448a1.05,1.05,0,0,0,.97.911l1.372.163c.474.047.686-.186.592-.724Z",
    transform: "translate(-121.094 -91.794)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4851",
    "data-name": "Trazado 4851",
    d: "M124.175,106.539l-1.4-.21c-.544-.094-.781.162-.71.724l.215,1.5a1.03,1.03,0,0,0,.968.934l1.42.14c.567.071.781-.163.685-.723l-.236-1.471a.968.968,0,0,0-.947-.888",
    transform: "translate(-102.575 -89.341)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeinsohn);
export default __webpack_public_path__ + "static/media/logoHeinsohn.56aeb1577438aa78aa45a4c1baeda6a2.svg";
export { ForwardRef as ReactComponent };